"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _cssjanus = _interopRequireDefault(require("cssjanus"));

var _stylis = require("stylis");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function stringifyPreserveComments(element, index, children, callback) {
  switch (element.type) {
    case _stylis.IMPORT:
    case _stylis.DECLARATION:
    case _stylis.COMMENT:
      return element["return"] = element["return"] || element.value;

    case _stylis.RULESET:
      {
        element.value = element.props.join(',');
        element.children.forEach(function (x) {
          if (x.type === _stylis.COMMENT) x.children = x.value;
        });
      }
  }

  return (0, _stylis.strlen)(children = (0, _stylis.serialize)(element.children, stringifyPreserveComments)) ? element["return"] = element.value + '{' + children + '}' : '';
}

function stylisRTLPlugin(element, index, children, callback) {
  if (!element.root) {
    var stringified = _cssjanus["default"].transform(stringifyPreserveComments(element, index, children, callback));

    element.children = stringified ? (0, _stylis.compile)(stringified)[0].children : [];
    element["return"] = '';
  }
} // stable identifier that will not be dropped by minification unless the whole module
// is unused


Object.defineProperty(stylisRTLPlugin, 'name', {
  value: 'stylisRTLPlugin'
});
var _default = stylisRTLPlugin;
exports["default"] = _default;